import {Switch, Tooltip, FormControl, FormLabel, FormHelperText, ModalDialog} from "@mui/joy";
import { useSelector, useDispatch } from 'react-redux';
import React, { useState } from "react";
import { Modal, IconButton, Box } from "@mui/joy";
import SettingsIcon from "@mui/icons-material/Settings";
import { useColorScheme } from "@mui/joy/styles";
import DarkModeIcon from "@mui/icons-material/DarkMode";
import LightModeIcon from "@mui/icons-material/LightMode";

export default function SettingsModal({}) {
    const dispatch = useDispatch();
    const [open, setOpen] = useState(false);
    const fillIdentical = useSelector((state) => state.identicalParticles.symmetrizationEnabled);
    const [symmetrizationEnabled, setSymmetrizationEnabled] = useState(fillIdentical);
    const { mode, setMode } = useColorScheme();
    const isDark = mode === 'dark';

    return (
        <>
            <IconButton onClick={() => setOpen(true)}>
                <SettingsIcon />
            </IconButton>
            <Modal
                open={open}
                onClose={() => setOpen(false)}
                sx={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                }}
            >
                <ModalDialog
                    sx={{
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                    }}
                >
                    <Box
                        sx={{
                            p: 3,
                            bgcolor: "background.body",
                            borderRadius: 2,
                        minWidth: 0,
                        boxShadow: 24,
                    }}
                >
                    <FormControl
                        orientation="horizontal"
                        sx={{ width: 300, justifyContent: 'space-between' }}
                    >
                        <div>
                            <FormLabel>Symmetrization</FormLabel>
                            <FormHelperText sx={{ mt: 0 }}>Enable node wise symmetrization.</FormHelperText>
                        </div>
                        <Tooltip title="Enable node wise symmetrization">
                            <Switch checked={symmetrizationEnabled} onChange={(e) => {
                                setSymmetrizationEnabled(e.target.checked)
                                dispatch({ type: "SET_SYMMETRIZATION", payload: e.target.checked })
                            }} />
                        </Tooltip>
                    </FormControl>
                    <FormControl
                        orientation="horizontal"
                        sx={{ width: 300, justifyContent: 'space-between', mt: 1 }}
                    >
                        <div>
                            <FormLabel>Dark mode</FormLabel>
                            <FormHelperText sx={{ mt: 0 }}>Switch between light and dark theme.</FormHelperText>
                        </div>
                        <Tooltip title={isDark ? "Switch to light mode" : "Switch to dark mode"}>
                            <Switch
                                checked={isDark}
                                onChange={() => setMode(isDark ? 'light' : 'dark')}
                                startDecorator={<LightModeIcon />}
                                endDecorator={<DarkModeIcon />}
                            />
                        </Tooltip>
                    </FormControl>
                </Box>
                </ModalDialog>
            </Modal>
        </>
    )
};
